import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';

export const AnnualEvolutionProcedures = () => {
    const { chartData } = useProceduresChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual do Total de Atendimentos no Município'}
            horizontal={false}
            subtitles={chartData?.annualEvolutionProcedures?.map((item) => item.description)}
            values={chartData?.annualEvolutionProcedures?.map((item) => item.total  ||  0)}
        />
    );
};
